import { useState, useEffect, useRef } from 'react';

const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleOnline = () => {
      console.log('🟢 Network: Back online');
      // ✅ FIXED: Use functional update to avoid dependency on isOnline
      setIsOnline(prevIsOnline => {
        if (!prevIsOnline) {
          setWasOffline(true);
        }
        return true;
      });
      
      // Clear any existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      
      // Reset wasOffline after a delay to prevent repeated notifications
      timeoutRef.current = setTimeout(() => {
        setWasOffline(false);
      }, 5000);
    };

    const handleOffline = () => {
      console.log('🔴 Network: Gone offline');
      setIsOnline(false);
      setWasOffline(false); // Reset when going offline
      
      // Clear any existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };

    // Add event listeners
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Cleanup function
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      
      // Clear timeout on cleanup
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []); // ✅ FIXED: Empty dependency array is now correct

  return { isOnline, wasOffline };
};

export default useNetworkStatus;